import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';

const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];

const Calendar = ({ date, matrix, setDate, decMonth, incMonth, decYear, incYear, today, onWeekSelect, weekStart, weekEnd }) => {
    const [selected, setSelected] = useState(date);
    const [month, setMonth] = useState(months[date.getMonth()].toUpperCase());
    const [year, setYear] = useState(date.getFullYear());

    useEffect(() => {
        setMonth(months[date.getMonth()].toUpperCase());
        setYear(date.getFullYear());
    }, [date])

    const getWeekBounds = (d) => {
        const clicked = new Date(date.getFullYear(), date.getMonth(), d);
        const dayOfWeek = clicked.getDay(); // 0=Sun, 1=Mon, ...
        const daysFromMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
        const monday = new Date(clicked);
        monday.setDate(clicked.getDate() - daysFromMonday);
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        return { monday, sunday };
    };

    const handleSelect = (dateNumber) => {
        if (!dateNumber) {
            return
        };

        if (onWeekSelect) {
            const { monday, sunday } = getWeekBounds(dateNumber);
            onWeekSelect(monday, sunday);
        } 
        else {
            const sel = new Date( date.getFullYear(), date.getMonth(), dateNumber, date.getHours(), date.getMinutes(), date.getSeconds());
            setSelected(sel);
            setDate(sel);
        }
    };

    const isInSelectedWeek = (d) => {
        if (!weekStart || !weekEnd || !d) return false;
        const day = new Date(date.getFullYear(), date.getMonth(), d);
        return day >= weekStart && day <= weekEnd;
    };

    const isToday = (d) => {
        const now = new Date();
        return (
            now.getDate() === d &&
            now.getFullYear() === date.getFullYear() &&
            now.getMonth() === date.getMonth()
        );
    };

    const isSelected = (d) => {
        if (selected === null) {
            return false;
        }
        return (
            selected.getDate() === d &&
            date.getMonth() === selected.getMonth() &&
            date.getFullYear() === selected.getFullYear()
        );
    };

    const getBgColor = (d) => {
        if (onWeekSelect) {
            return isInSelectedWeek(d) ? 'bg-portal-blue-primary' : '';
        }
        if (isSelected(d)) {
            return 'bg-portal-blue-primary';
        } else if (isToday(d)) {
            return 'bg-gray-300';
        } else {
            return '';
        }
    };

    const getTextColor = (d) => {
        if (onWeekSelect) {
            return isInSelectedWeek(d) ? 'text-gray-100' : 'text-gray-600';
        }
        if (isSelected(d)) {
            return 'text-gray-100';
        } else {
            return 'text-gray-600';
        }
    };

    return (
        <div className="w-full p-2" id='calendar'>
            <div className="w-full flex flex-row justify-between items-center my-1">
                <div className="whitespace-no-wrap">
                    <button type="button" id="decYear" className="mx-1 text-gray-700 hover:text-portal-blue-primary" onClick={() => decYear()}>
                        <FontAwesomeIcon icon={faAngleDoubleLeft} />
                    </button>
                    <button type="button" id="decMonth" className="mx-3 text-gray-700 hover:text-portal-blue-primary" onClick={() => decMonth()}>
                        <FontAwesomeIcon icon={faAngleLeft} />
                    </button>
                </div>
                <button type="button"
                    className="font-bold text-xs mx-3 rounded py-1 px-2 text-gray-700 hover:text-portal-blue-primary"
                    style={{ minWidth: '9rem', textAlign: 'center' }}
                    onClick={() => today()}>
                    {month} {year}
                </button>
                <div className="whitespace-no-wrap">
                    <button type="button" id="incMonth" className="mx-3 text-gray-700 hover:text-portal-blue-primary" onClick={() => incMonth()}>
                        <FontAwesomeIcon icon={faAngleRight} />
                    </button>
                    <button type="button" id="incYear" className="mx-1 text-gray-700 hover:text-portal-blue-primary" onClick={() => incYear()}>
                        <FontAwesomeIcon icon={faAngleDoubleRight} />
                    </button>
                </div>
            </div>
            <table className="w-full">
                <thead>
                    <tr>
                        {days.map((day, i) => (
                            <th key={`day${i}`} className="text-xs p-0" >{day.slice(0, 3).toUpperCase()}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {matrix.map((row, rowIndex) => (
                        <tr key={`row${rowIndex}`}>
                            {row.map((item, i) => (
                                <td
                                    key={i}
                                    className={`text-xs font-light text-center p-0 ${getBgColor(item)} ${getTextColor(item)}`}>
                                    <button type="button" onClick={() => handleSelect(item)}>
                                        {item > 0
                                            ? item
                                            : ''
                                        }
                                    </button>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

/*
function Calendar({ onSelect, initDate = null }) {
  const { date, matrix, decMonth, decYear, incMonth, incYear, today } = useDate(initDate);
  const [selected, setSelected] = useState(initDate);

  const handleSelect = (d) => {
    const selected = new Date(
      date.getFullYear(),
      date.getMonth(),
      d,
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    );
    setSelected(selected);
    onSelect(selected);
  };

  const isToday = (d) => {
    const now = new Date();
    return (
      now.getDate() === d &&
      now.getFullYear() === date.getFullYear() &&
      now.getMonth() === date.getMonth()
    );
  };

  const isSelected = (d) => {
    if (selected === null) {
      return false;
    }
    return (
      selected.getDate() === d &&
      date.getMonth() === selected.getMonth() &&
      date.getFullYear() === selected.getFullYear()
    );
  };

  const getBgColor = (d) => {
    if (isSelected(d)) {
      return 'bg-portal-blue-primary';
    } else if (isToday(d)) {
      return 'bg-gray-300';
    } else {
      return '';
    }
  };

  const getTextColor = (d) => {
    if (isSelected(d)) {
      return 'text-gray-100';
    } else {
      return 'text-gray-600';
    }
  };

  return (
    <div className="w-full p-2">
      <div className="w-full flex flex-row justify-between my-1">
        <div>
          <button className="mx-1 text-gray-700 hover:text-portal-blue-primary" onClick={() => decYear()}>
            <FontAwesomeIcon icon={faAngleDoubleLeft} />
          </button>
          <button className="mx-3 text-gray-700 hover:text-portal-blue-primary" onClick={() => decMonth()}>
            <FontAwesomeIcon icon={faAngleLeft} />
          </button>
        </div>
        <button
          className="font-bold text-xs mx-3 rounded py-1 px-2 text-gray-700 hover:text-portal-blue-primary"
          style={{ minWidth: '9rem', textAlign: 'center' }}
          onClick={() => today()}
        >
          {months[date.getMonth()].toUpperCase()} {date.getFullYear()}
        </button>
        <div>
          <button className="mx-3 text-gray-700 hover:text-portal-blue-primary" onClick={() => incMonth()}>
            <FontAwesomeIcon icon={faAngleRight} />
          </button>
          <button className="mx-1 text-gray-700 hover:text-portal-blue-primary" onClick={() => incYear()}>
            <FontAwesomeIcon icon={faAngleDoubleRight} />
          </button>
        </div>
      </div>
      <table className="w-full">
        <thead>
          <tr>
            { days.map((day, i) => (
              <th key={`day${i}`} className="text-xs p-0" >{day.slice(0, 3).toUpperCase()}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          { matrix.map((row, rowIndex) => (
            <tr key={`row${rowIndex}`}>
              {row.map((item, i) => (
                <td
                  key={i}
                  className={`text-xs font-light text-center p-0 ${getBgColor(item)} ${getTextColor(item)}`}
                >
                  <button onClick={() => handleSelect(item)}>
                    {item > 0
                      ? item
                      : ''
                    }
                  </button>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
*/
export default Calendar;
